<template>
  <RegistrationPayment/>
</template>

<script>
import RegistrationPayment from "@/components/Authentication/RegistrationContent/RegistrationPayment";

export default {
  name: "RegistrationPage",
  components: {RegistrationPayment}
};
</script>

<style scoped>

</style>